/**
 * Labstep
 *
 * @module components/PurchaseOrder/Filter/Pane
 * @desc Filter pane for purchaseOrder request
 */

import { FilterPane } from 'labstep-web/components/Filter/Pane';
import { PurchaseOrderFilterStatusList } from 'labstep-web/components/PurchaseOrder/Filter/Status/List';
import { ICONS } from 'labstep-web/constants/icons';
import type React from 'react';

export const PurchaseOrderFilterPane: React.FC = () => (
  <FilterPane
    entityName="purchase_order"
    filters={[]}
    extraFilters={<PurchaseOrderFilterStatusList />}
    icon={ICONS.purchase_order.primary}
    text={'Orders'}
  />
);
